import React from 'react';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  _NkInput as NkInput,
  _NkCheckbox as NkCheckbox,
} from '@nordkap/nordkap-ui';
import { useStyles } from '../styles';

const AccountingObject = props => {
  const classes = useStyles();
  const { t } = useTranslation();

  const handleChange = (event, name) => {
    event.target.name = name;
    props.changeObject(event);
  };

  return (
    <>
      <Grid
        container
        item
        xs={2}
        sm={1}
        justifyContent="center"
        alignItems="center"
        title={t('accountingObject.title')}
      >
        {props.object.index}
      </Grid>
      <Grid container item xs={5} justifyContent="center" alignItems="center">
        <NkInput
          name={`${props.object.index}-name`}
          type="text"
          variant="outlined"
          value={props.object.name || ''}
          placeholder={t('accountingObject.name')}
          onChange={event => handleChange(event, `${props.object.index}-name`)}
        />
      </Grid>
      <Grid container xs={2} md={1} className={classes.checkboxWrapper}>
        <NkCheckbox
          name={`${props.object.index}-active`}
          value={props.object.active || false}
          onChange={event =>
            handleChange(event, `${props.object.index}-active`)
          }
          useCustomIcons={false}
        />
      </Grid>
      <Grid item container xs={3} sm={4} md={5} />
    </>
  );
};

AccountingObject.propTypes = {
  object: PropTypes.object,
  changeObject: PropTypes.func,
};

export default AccountingObject;
